export const RGPBannerData = {
    ch: {
        "data": {
            "item": {
                "key": "RGPBanner",
                "enable": {
                    "value": "1"
                },
                "massSiteEnable": {
                    "value": "1"
                },
                "speedbetEnable": {
                    "value": "1"
                },
                "chinaSiteEnable": {
                    "value": "1"
                },
                "header": {
                    "value": "博彩要有節制"
                },
                "text1": {
                    "value": ""
                },
                "text2": {
                    "value": "<p>未滿十八歲人士不得投注或進入可投注的地方。</p>\n<p>向非法或海外莊家下注，即屬違法，且可被判監禁。</p>\n<p>切勿沉迷賭博，如需尋求輔導協助，可致電平和基金熱線1834 633。</p>"
                },
                "icon": {
                    "src": "//consvc.hkjc.com/-/media/Sites/JCBW/RGP_CHI.PNG?rev=c381a0ba675a4e3f95326cb4166273b4&sc_lang=zh-HK",
                    "width": 121,
                    "height": 74
                },
                "itemRedirection": {
                    "value": "Other link"
                },
                "itemLink": {
                    "value": "https://www.hkjc.com/responsible-gambling/ch/index.aspx"
                },
                "itemPage": {
                    "value": ""
                },
                "redirectMethod": {
                    "value": "New tab in original browser"
                },
                "pH": {
                    "value": ""
                },
                "pW": {
                    "value": ""
                },
                "pX": {
                    "value": ""
                },
                "pY": {
                    "value": ""
                }
            }
        }
    },
    en: {
        "data": {
            "item": {
                "key": "RGPBanner",
                "enable": {
                    "value": "1"
                },
                "massSiteEnable": {
                    "value": "1"
                },
                "speedbetEnable": {
                    "value": "1"
                },
                "chinaSiteEnable": {
                    "value": "1"
                },
                "header": {
                    "value": "Play Responsibly"
                },
                "text1": {
                    "value": ""
                },
                "text2": {
                    "value": "<p>No person under 18 is allowed to bet or enter premises where bets are accepted.</p>\n<p>Betting with illegal or overseas bookmakers is against the law and offenders may be liable to imprisonment.</p>\n<p>Don<span style=\"font-family: arial;\">&rsquo;</span>t gamble your life away. Call Ping Wo Fund hotline 1834 633 if you need help or counselling.</p>"
                },
                "icon": {
                    "src": "//consvc.hkjc.com/-/media/Sites/JCBW/rgp_text_eng_970.gif?rev=2b742e675a8f4e1a801daa5fc54f50a8&sc_lang=en-US",
                    "width": 72,
                    "height": 50
                },
                "itemRedirection": {
                    "value": "Other link"
                },
                "itemLink": {
                    "value": "https://www.hkjc.com/responsible-gambling/en/index.aspx"
                },
                "itemPage": {
                    "value": ""
                },
                "redirectMethod": {
                    "value": "New tab in original browser"
                },
                "pH": {
                    "value": ""
                },
                "pW": {
                    "value": ""
                },
                "pX": {
                    "value": ""
                },
                "pY": {
                    "value": ""
                }
            }
        }
    }
}